// extracted by mini-css-extract-plugin
export default {"Input":"TextInput_Input__U88W0","error":"TextInput_error__hssvE"};